var jstz = require('../../../node_modules/jstimezonedetect/jstz.js');

window.jstz = jstz.jstz;